import { createAmplitudeEvent } from "@dcc/shared/amplitude";

export const fromEmailReferrer = createAmplitudeEvent("From email referrer");
